import {FormGroup, InputGroup, Intent, Spinner, SpinnerSize} from "@blueprintjs/core";
import * as React from "react";

import {handleChangeString} from "../../../utils/handle-change";
import {ValidationResult} from "../../../utils/validation/validation-result";

interface IValidatedInputTextProps {
    className?: string;
    autoFocus?: boolean;
    value: string;
    validationResult: ValidationResult;
    validationInProgress?: boolean;
    onChangeValue: (value: string) => void;
    label?: string;
    helperText?: React.ReactNode;
    helperIntent?: Intent;
    large?: boolean;
    placeholder?: string;
    maxLength?: number;
    style?: React.CSSProperties;
    type?: string;
    rightElement?: React.ReactElement;
    disabled?: boolean;
    readOnly?: boolean;
    labelForId?: string;
    ariaLabel?: string;
    dataTestId?: string;
}

export const ValidatedInputText: React.FC<IValidatedInputTextProps> = (props) => {
    const hasError = !props.validationResult.isEmpty;
    const resolvedHelperText = hasError ? props.validationResult.simpleMessage : props.helperText;
    const resolvedIntent = hasError ? Intent.DANGER : props.helperIntent ?? Intent.NONE;

    return (
        <FormGroup
            className={props.className}
            label={props.label}
            intent={resolvedIntent}
            helperText={resolvedHelperText}
            labelFor={props.labelForId}
        >
            <InputGroup
                id={props.labelForId}
                aria-label={props.ariaLabel}
                data-testid={props.dataTestId}
                type={props.type}
                style={props.style}
                value={props.value}
                large={props.large}
                intent={resolvedIntent}
                placeholder={props.placeholder}
                onChange={handleChangeString(props.onChangeValue)}
                maxLength={props.maxLength}
                rightElement={
                    props.validationInProgress ? (
                        <Spinner size={SpinnerSize.SMALL} />
                    ) : (
                        props.rightElement
                    )
                }
                autoFocus={props.autoFocus}
                disabled={props.disabled}
                readOnly={props.readOnly}
            />
        </FormGroup>
    );
};
